import { createSlice } from "@reduxjs/toolkit";

const address = {
  city: "",
  county: "",
  zipCode: "",
  address1: ""
};

const studentFamilyMember = {
  isDead: false,
  tcKimlikNo: "",
  name: "",
  surname: "",
  occupation: "",
  phone1: "",
  phone2: "",
  email: "",
  relationship: "",
  occupationCategories: [],
  educationalBackground: {
    university: "",
    department: "",
    graduationYear: ""
  },
  workAddress: address,
  homeAddress: address
};

const initialStudent = {
  studentNumber: "",
  tcKimlikNo: "",
  name: "",
  surname: "",
  sexName: "",
  section: "",
  phone: "",
  email: "",
  facebook: "",
  twitter: "",
  father: studentFamilyMember,
  mother: studentFamilyMember,
  other: studentFamilyMember
};

const initialMyStudentsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  sections: [],
  student: initialStudent
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const myStudentSlice = createSlice({
  name: "myStudents",
  initialState: initialMyStudentsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getStudent
    studentFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.student = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanMyStudentsState
    myStudentsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.student = initialStudent;
    }
  }
});